var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "app-main-inner-row" }, [
          _c("div", { staticClass: "filters" }),
          _c(
            "div",
            { staticClass: "triggers" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.editHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger", size: "mini" },
                  on: { click: _vm.removeHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.uploadHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Upload")))]
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%" },
              attrs: {
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData,
                "grid-options": _vm.gridOptions,
                "side-bar": _vm.sideBarDefs
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog",
          attrs: {
            slot: "reference",
            "close-on-click-modal": false,
            visible: _vm.showEditDialog,
            title: _vm.title,
            "inline-message": "",
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showEditDialog = $event
            }
          },
          slot: "reference"
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.form,
                "label-width": "150px",
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("SystemMaintenance.CloudStorageID") }
                },
                [
                  _c("el-input", {
                    attrs: { size: "mini", disabled: "" },
                    model: {
                      value: _vm.form.storageId,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "storageId", $$v)
                      },
                      expression: "form.storageId"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SystemMaintenance.TemplateName") } },
                [
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.form.templateName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "templateName", $$v)
                      },
                      expression: "form.templateName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SystemMaintenance.Remark") } },
                [
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.form.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remarks", $$v)
                      },
                      expression: "form.remarks"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "SchemaType" } },
                [
                  _c("el-input", {
                    attrs: { size: "mini", disabled: "" },
                    model: {
                      value: _vm.form.schemaType,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "schemaType", $$v)
                      },
                      expression: "form.schemaType"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini ", type: "primary" },
                  on: { click: _vm.submitHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini " }, on: { click: _vm.cancelHandler } },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }